import { toDateFormatted } from '@/common/utils/date';

export class Clock {
  dateTime: Date;

  constructor(date = new Date()) {
    this.dateTime = date;
  }

  update(date: Date) {
    this.dateTime = date;
  }

  time() {
    return toDateFormatted(this.dateTime, 'HH:mm:ss');
  }

  timeZoneName() {
    return toDateFormatted(this.dateTime, 'Z');
  }

  utcOffset() {
    return toDateFormatted(this.dateTime, 'zzz');
  }
}
